export default __webpack_public_path__ + "6524cb44df9bf689e46111b6640d668f.png";